import React, { useEffect } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ConnectedRoute from '@AppRoutes/ConnectedRoute';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Footer from '@Components/Footer';
import { paths } from '@AppRoutes/constants';

import Account from './Account/AccountContainer';
import Profile from './Profile/ProfileContainer';
import Preferences from './Preferences/PreferencesContainer';
import ProfileSettingsHeader from './Components/ProfileSettingsHeader';

import './ProfileSettings.scss';

const spinnerId = 'profile-settings';

export default function ProfileSettings({ openSupplierPreferences, isLoading, init }) {
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  return (
    <section className="react-page-static profile-setting-page react-page">
      <section className="react-page-static__wrapper react-page--children-wrapper">
        <div className="profile-setting" id="main-content">
          <ProfileSettingsHeader />
          {isLoading && <SimpleSpinner id={spinnerId} />}
          {!isLoading && (
            <div className="profile-setting__content">
              <div className="profile-setting__content_tab">
                <Switch>
                  <ConnectedRoute path={paths.PROFILE_ACCOUNT} render={() => <Account />} />
                  <ConnectedRoute path={paths.PROFILE_PROFILE} render={() => <Profile />} />
                  <ConnectedRoute
                    path={paths.PROFILE_PREFERENCES}
                    render={() => <Preferences openSupplierPreferences={openSupplierPreferences} />}
                  />
                  <Redirect from="/profile-settings" to="/profile-settings/account" />
                </Switch>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </section>
  );
}

ProfileSettings.propTypes = {
  openSupplierPreferences: PropTypes.bool,
  isLoading: PropTypes.bool,
  init: PropTypes.func.isRequired,
};
